const PLAN_TYPE_MAP = {
  CORPORATE_HEALTH_INSURANCE: "Corporate Health Insurance",
  MOTOR_INSURANCE: "Motor Insurance",
  LIFE_INSURANCE: "Life Insurance",
  PLATFORM_OPD: "OPD Plan",
};

export function getPlanTypeLabel(planType) {
  if (!planType) return null;
  return PLAN_TYPE_MAP[planType] || planType;
}

export function getPlanId(plan, fallbackIndex) {
  return plan?.planId ?? plan?.planName ?? plan?.name ?? `plan-${fallbackIndex}`;
}
